<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isFetchingBranches" :can-cancel="false"></b-loading>
    <h3 class="title is-3">Manage Branch</h3>
    <hr />
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Branch Code</label>
          <div class="control">
            <input type="text" v-model="branch.branchCode" class="input is-small" readonly />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Name</label>
          <div class="control">
            <input type="text" v-model="branch.name" class="input is-small" v-validate="'required'" name="Branch name" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Branch name') }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Desc</label>
          <div class="control">
            <input type="text" v-model="branch.desc" class="input is-small" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Biometrics IP</label>
          <div class="control">
            <input type="text" v-model="branch.biometricsIp" class="input is-small" placeholder="###.##.#.###" />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Biometrics Port</label>
          <div class="control">
            <input type="number" v-model="branch.biometricsPort" class="input is-small" placeholder="####" />
          </div>
        </div>
      </div>
    </div>
    <button :class="buttonSave" @click="saveBranch">{{createOrEdit}}</button>
    &nbsp;
    <span v-show="createOrEdit == 'Update'">
      <button class="button is-small" @click="cancelEdit">Cancel</button>
      &nbsp;
    </span>
    <button class="button is-small" @click="getBranches">Refresh table</button>
    <div style="clear:both"></div>
    <br />
    <b-table :data="branches" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true">
      <template slot-scope="item">
        <b-table-column field="branchCode" class="table-column-content-is-small" label="Branch Code">
          {{item.row.branchCode}}
        </b-table-column>
        <b-table-column field="departmentId" class="table-column-content-is-small" label="Name">
          {{item.row.name}}
        </b-table-column>
        <b-table-column field="departmentId" class="table-column-content-is-small" label="Desc.">
          {{item.row.desc}}
        </b-table-column>
        <b-table-column field="departmentId" class="table-column-content-is-small" label="Biometrics IP">
          {{item.row.biometricsIp}}
        </b-table-column>
        <b-table-column field="departmentId" class="table-column-content-is-small" label="Biometrics Port">
          {{item.row.biometricsPort}}
        </b-table-column>
        <b-table-column field="departmentId" class="table-column-content-is-small" label="Total Employees">
          {{item.row.totalEmployee}}
        </b-table-column>
        <b-table-column field="connected" class="table-column-content-is-small" label="Connection">
          <center>
            <span v-if="item.row.isConnected" title="Connected">
              <img src="../../assets/connected.png" width="30" />
            </span>
            <span v-if="!item.row.isConnected" title="Disconnected">
              <img src="../../assets/disconnected.png" width="30" />
            </span>
          </center>
        </b-table-column>
        <b-table-column>
          <button class="button is-small is-warning" @click="editBranch(item.row.branchId)">Edit</button> &nbsp;
          <button class="button is-small is-danger" @click="deleteBranch(item.row.branchId)">Delete</button>
        </b-table-column>
      </template>
    </b-table>
    <div>
    </div>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete Branch</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          Are you sure do you want to delete this permanently?
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="buttonDelete" @click="deletePermanently">Yes</button>
          <button class="button is-small" @click="cancel">No</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    createOrEdit: 'Create',
    showDeleteModal: false,
    branch: {
      branchCode: '(Auto Generate)'
    },
    branches: [],
    isFetchingBranches: false,
    buttonSave: appButton.isLoadingSuccess(false),
    buttonDelete: appButton.isLoadingDanger(false)
  }),
  created() {
    this.getBranches()
  },
  methods: {
    saveBranch() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          const branchId = this.branch.branchId
          if (branchId) {
            // Edit
            axios
              .put(`api/branches/${branchId}`, this.branch)
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                console.log(error)
              })
              .then(() => {
                this.default()
              })
          } else {
            axios
              .post(`api/branches`, this.branch)
              .then(response => {
                appToast.success(response.data)
              })
              .catch(error => {
                console.log(error)
              })
              .then(response => {
                this.default()
              })
          }
        }
      })
    },
    getBranches() {
      this.isFetchingBranches = true
      axios
        .get('api/branches')
        .then(response => {
          this.branches = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingBranches = false
        })
    },
    editBranch(id) {
      axios
        .get(`api/branches/${id}`)
        .then(response => {
          this.branch = response.data
          this.createOrEdit = 'Update'
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteBranch(id) {
      this.showDeleteModal = true
      this.branch.branchId = id
    },
    deletePermanently() {
      if (this.showDeleteModal) {
        this.buttonDelete = appButton.isLoadingDanger(true)
        const branchId = this.branch.branchId
        if (branchId) {
          axios
            .delete(`api/branches/${branchId}`)
            .then(response => {
              appToast.success(response.data)
            })
            .catch(error => {
              console.log(error)
            })
            .then(() => {
              this.default()
            })
        }
      }
    },
    cancel() {
      this.showDeleteModal = false
    },
    default() {
      this.createOrEdit = 'Create'
      ;(this.branch = {
        branchCode: '(Auto Generate)'
      }),
        (this.showDeleteModal = false)
      this.getBranches()
      this.buttonSave = appButton.isLoadingSuccess(false)
      this.buttonDelete = appButton.isLoadingDanger(false)

      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    cancelEdit() {
      this.default()
    }
  }
}
</script>

<style>
.dot-green {
  height: 15px;
  width: 15px;
  background-color: #00ff00;
  border-radius: 50%;
  display: inline-block;
}

.dot-red {
  height: 15px;
  width: 15px;
  background-color: #f22613;
  border-radius: 50%;
  display: inline-block;
}
</style>